export const FlowTypes = {
  CHECKOUT: 'CHECKOUT',
  ORDER: 'ORDER',
  TOP_UP: 'TOPUP',
}
